import { Reveal } from "../components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { FAQS } from "../lib/content";
import { useLang } from "../lib/i18n";

export const Faq = () => {
  const { c } = useLang();
  return (
  <section id="faq" className="py-28 sm:py-40 px-6" data-testid="faq-section">
    <div className="max-w-3xl mx-auto">
      <Reveal>
        <h2 className="font-serif-display font-light text-4xl sm:text-5xl">
          {c.faq.title} <span className="italic text-[#465220]">{c.faq.titleAccent}</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1} className="mt-14">
        <Accordion type="single" collapsible className="w-full">
          {c.faq.items.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-[#DFE4D0]">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="font-serif-display text-xl sm:text-2xl font-medium text-left hover:no-underline hover:text-[#465220] py-6"
              >
                <span className="flex items-baseline gap-4">
                  <span className="font-light text-sm text-[#E15A70] tabular-nums">{String(i + 1).padStart(2, "0")}</span>
                  {f.q}
                </span>
              </AccordionTrigger>
              <AccordionContent className="text-base font-light leading-relaxed text-[#2C3552]/70 pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
  );
};

export const Registry = () => {
  const { c } = useLang();
  return (
  <section id="registry" className="py-28 sm:py-40 px-6 bg-[#EEF2E3]" data-testid="registry-section">
    <div className="max-w-3xl mx-auto text-center">
      <Reveal>
        <h2 className="font-serif-display font-light text-4xl sm:text-5xl leading-tight">
          {c.registry.title} <span className="italic text-[#465220]">{c.registry.titleAccent}</span>
        </h2>
        <p className="mt-8 text-base sm:text-lg font-light leading-relaxed text-[#2C3552]/70 max-w-xl mx-auto">
          {c.registry.body}
        </p>
        <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center">
          <a
            data-testid="registry-honeymoon-btn"
            href="https://www.honeyfund.com/site/rascon-velasco-03-27-2027"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[11px] uppercase tracking-[0.3em] px-10 py-4 rounded-full bg-[#2C3552] text-[#FAFAF1] hover:bg-[#465220] hover:-translate-y-0.5 transition-[background-color,transform] duration-300"
          >
            {c.registry.button}
          </a>
        </div>
      </Reveal>
    </div>
  </section>
  );
};
